/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { createListResourceActions, ListResourceReducer, ListResourceState } from '@common/tech-shared';
import { ActionReducerMap } from '@ngrx/store';
import { SETTINGS_FEATURE_KEY, SETTINGS_LIST_PATH } from '../settings.state';

export interface SettingsParentState {
  [SETTINGS_LIST_PATH]: ListResourceState;
}

export const settingsReducer: ActionReducerMap<SettingsParentState> = {
  [SETTINGS_LIST_PATH]: settingsListResourceReducer,
};

function settingsListResourceReducer(state: ListResourceState, action: any): ListResourceState {
  const resourceReducer: ListResourceReducer = new ListResourceReducer(
    createListResourceActions({ name: SETTINGS_FEATURE_KEY, path: SETTINGS_LIST_PATH }),
  );
  return resourceReducer.reducer(state, action);
}
